var React = require('react');

function Vector (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.33198 0.575195L0 2.12047L4.32659 7.15082L0 12.1812L1.33198 13.7264L7 7.15082L1.33198 0.575195Z","fill":"#005DFF"}));
}

Vector.defaultProps = {"width":"7","height":"14","viewBox":"0 0 7 14","fill":"none"};

module.exports = Vector;

Vector.default = Vector;
